<template>
  <div style="width: 100%; margin-bottom: 20px;">

    <!-- 误差图表 -->
    <div v-if="type==='动态聚散'"
      style="width: 100%;
      margin-bottom: 20px;"
      >
      <div ref="errorChart" style="width: 754px;height:300px;margin-bottom: 20px;"></div>
      <div style="width: 100%;height: 1px;background-color: #D5DCE5;"></div>
    </div>

    <!-- 分数图表 -->
    <div style="width: 100%;margin-bottom: 20px;">
      <div ref="scoreChart" style="width: 754px;height:300px"></div>
    </div>

    <!-- 立体视训练 -->
    <div v-if="type==='立体视训练'">
      <Row style="justify-content: space-between;">
        <div class="stereo-table-cell" style="width: 149px;background: #D2F2E9;">
          最大立体视
        </div>
        <div class="stereo-table-cell" style="width: 149px;background: #D2F2E9;">
          最小立体视
        </div>
        <div class="stereo-table-cell" style="width: 149px;background: #D2F2E9;">
          平均反应时间
        </div>
        <div class="stereo-table-cell" style="width: 149px;background: #D2F2E9;">
          正确率
        </div>
        <div class="stereo-table-cell" style="width: 149px;background: #D2F2E9;">
          完成次数
        </div>
      </Row>
      <Row style="justify-content: space-between;margin-top: 2px">
        <div class="stereo-table-cell" style="width: 149px;">
          {{ maxLevel }}
        </div>
        <div class="stereo-table-cell" style="width: 149px;">
          {{ minLevel }}
        </div>
        <div class="stereo-table-cell" style="width: 149px;">
          {{ repTimeAvg }}
        </div>
        <div class="stereo-table-cell" style="width: 149px;">
          {{ accuracy }}
        </div>
        <div class="stereo-table-cell" style="width: 149px;">
          {{ scoreList.length }}
        </div>
      </Row>
    </div>

    <div v-if="type==='融像范围扩大' || type==='快速融像'">
      <Row style="justify-content: space-between;">
        <div class="stereo-table-cell" style="width: 106px;background: #D2F2E9;">
          训练类型
        </div>
        <div class="stereo-table-cell" style="width: 106px;background: #D2F2E9;">
          最大能力
        </div>
        <div class="stereo-table-cell" style="width: 106px;background: #D2F2E9;">
          最小可恢复能力
        </div>
        <div class="stereo-table-cell" style="width: 106px;background: #D2F2E9;">
          最大回撤
        </div>
        <div class="stereo-table-cell" style="width: 106px;background: #D2F2E9;">
          平均反应时间
        </div>
        <div class="stereo-table-cell" style="width: 106px;background: #D2F2E9;">
          正确率
        </div>
        <div class="stereo-table-cell" style="width: 106px;background: #D2F2E9;">
          完成次数
        </div>
      </Row>
      <Row style="justify-content: space-between;margin-top: 2px">
        <div class="stereo-table-cell" style="width: 106px;">
          {{ rxType }}
        </div>
        <div class="stereo-table-cell" style="width: 106px;">
          {{ maxPrism }}
        </div>
        <div class="stereo-table-cell" style="width: 106px;">
          {{ minTurn }}
        </div>
        <div class="stereo-table-cell" style="width: 106px;">
          {{ maxReturn }}
        </div>
        <div class="stereo-table-cell" style="width: 106px;">
          {{ repTimeAvg }}
        </div>
        <div class="stereo-table-cell" style="width: 106px;">
          {{ accuracy }}
        </div>
        <div class="stereo-table-cell" style="width: 106px;">
          {{ scoreList.length }}
        </div>
      </Row>
    </div>

    <!-- 动态聚散训练 -->
    <div v-if="type==='动态聚散'">
      <Row style="justify-content: space-between;">
        <div class="stereo-table-cell" style="width: 187px;background: #D2F2E9;">
          最高等级
        </div>
        <div class="stereo-table-cell" style="width: 187px;background: #D2F2E9;">
          平均反应时间
        </div>
        <div class="stereo-table-cell" style="width: 187px;background: #D2F2E9;">
          正确率
        </div>
        <div class="stereo-table-cell" style="width: 187px;background: #D2F2E9;">
          完成次数
        </div>
      </Row>
      <Row style="justify-content: space-between;margin-top: 2px">
        <div class="stereo-table-cell" style="width: 187px;">
          {{ maxLevel }}
        </div>
        <div class="stereo-table-cell" style="width: 187px;">
          {{ repTimeAvg }}
        </div>
        <div class="stereo-table-cell" style="width: 187px;">
          {{ accuracy }}
        </div>
        <div class="stereo-table-cell" style="width: 187px;">
          {{ scoreList.length }}
        </div>
      </Row>
    </div>

  </div>
</template>

<script>

import echarts from 'echarts';

export default {
  name: 'StereoEchart',
  components: {

  },
  props: {
    stereoData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      type: '',
      cdStatusList: [],
      scoreList: [],
      repTimeAvg: '',
      maxLevel: '',
      minLevel: '',
      // 训练类型, 集合/散开
      rxType: '',
      // 最大能力
      maxPrism: '',
      // 最小可恢复能力
      minTurn: '',
      // 最大回撤
      maxReturn: '',
      accuracy: '',

      // 立体视训练, 最大最小立体视
      maxArcSecond: '',
      minArcSecond: '',
    };
  },
  async created() {
    this.type = this.stereoData['训练难度'];
    if (this.stereoData.score_list) {
      this.scoreList = this.stereoData.score_list;
    }

    if (this.stereoData.cd_status_list) {
      this.cdStatusList = this.stereoData.cd_status_list;
    }
    this.rxType = this.stereoData['训练类型'];

    let divideNum = 20;
    if (this.type === '快速融像') {
      // 不除20
      divideNum = 1;
    }

    this.maxPrism = (this.stereoData.max_prism !== null && this.stereoData.max_prism !== '')
      ? `${this.calRound(Math.abs(this.stereoData.max_prism) / divideNum, 0)}▲` : '无';
    this.minTurn = (this.stereoData.min_turn !== null && this.stereoData.min_turn !== '')
      ? `${this.calRound(this.stereoData.min_turn / divideNum, 0)}▲` : '无';
    if (this.minTurn === '无') {
      this.maxReturn = '无';
    } else {
      this.maxReturn = (this.stereoData.max_return !== null && this.stereoData.max_return !== '')
        ? `${this.calRound(Math.abs(this.stereoData.max_return) / divideNum, 0)}▲` : '无';
    }

    this.accuracy = `${this.calRound(this.stereoData.accuracy * 100, 0)}%`;
    this.$nextTick(() => {
      this.initScoreChart();
      if (this.type === '动态聚散') {
        this.initErrorChart();
      }
    });
  },
  methods: {
    calRound(num, scale) {
      // 小数位
      let scaleNum = 10 ** scale;
      if (scale === 0) {
        // 取整
        scaleNum = 1;
      }
      return Math.round(num * scaleNum) / scaleNum;
    },
    initScoreChart() {
      const chartDom = this.$refs.scoreChart;
      const scoreChart = echarts.init(chartDom);

      const trueRepTimes = [];
      const falseRepTimes = [];
      const levels = [];

      const allRepTimeSecList = [];
      const allLevels = [];
      const allArcSecond = [];

      this.scoreList.forEach((item, index) => {
        const xIndex = index + 1;

        const repTimeSec = this.calRound((item.repTime / 1000), 1);

        if (this.type === '立体视训练') {
          let { arcSecond } = item;
          if (arcSecond) {
            arcSecond = this.calRound((item.arcSecond), 1);
            allArcSecond.push(arcSecond);
          }
        }

        if (item.answer) {
          trueRepTimes.push([xIndex, repTimeSec]);
          // 正确的需要在1的位置显示红色方块
          falseRepTimes.push([xIndex, 1]);
        } else {
          falseRepTimes.push([xIndex, 0]);
        }

        let { level } = item;
        if (this.type === '融像范围扩大') {
          level = this.calRound((level / 20), 1);
        } else if (this.type === '立体视训练') {
          level = this.calRound((item.arcSecond), 0);
        }
        levels.push([xIndex, level]);

        allRepTimeSecList.push(repTimeSec);

        allLevels.push(level);
      });

      // 计算平均反应时间, 秒
      if (allRepTimeSecList.length > 0) {
        this.repTimeAvg = `${this.calRound((allRepTimeSecList.reduce((sum, val) => sum + val * 100, 0) / 100 / allRepTimeSecList.length), 1)}s`;
      }

      // 计算最大/最小立体视
      if (allLevels.length > 0) {
        this.maxLevel = `${Math.max(...allLevels)}″`;
        this.minLevel = `${Math.min(...allLevels)}″`;
      }

      // 计算立体视训练 最大最小立体视
      if (allArcSecond.length > 0) {
        this.maxArcSecond = `${Math.max(...allArcSecond)}″`;
        this.minArcSecond = `${Math.min(...allArcSecond)}″`;
      }

      if (this.type === '动态聚散') {
        // 动态聚散的最高等级需要转成5/5、6/6、7/7、7/10
        const maxLevelNum = Math.max(...allLevels);
        if (maxLevelNum === 5) {
          this.maxLevel = '5/5';
        } else if (maxLevelNum === 6) {
          this.maxLevel = '6/6';
        } else if (maxLevelNum === 7) {
          this.maxLevel = '7/7';
        } else if (maxLevelNum === 10) {
          this.maxLevel = '7/10';
        }
      }

      let rightYAxisTitle = '最大能力';
      if (this.type === '立体视训练') {
        rightYAxisTitle = '难度';
      }

      const option = {
        grid: {
          top: '10%',
          left: '7%',
          bottom: '7%',
          right: '7%',
        },
        xAxis: {
          type: 'value',
          min: 0,
          minInterval: 1,
          max: this.scoreList.length > 0 ? this.scoreList.length + 1 : 0,
          axisLabel: {
            color: '#000000',
            formatter: (value) => {
              if (value > this.scoreList.length) {
                return '次';
              }
              return value;
            },
            showMinLabel: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#D5DCE5',
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#D5DCE5',
              type: 'dashed',
              dashOffset: 3,
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            name: '反应时间（S）',
            nameTextStyle: {
              color: '#000000',
            },
            position: 'left',
            axisLabel: {
              color: '#000000',
              formatter: '{value}',
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#D5DCE5',
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#D5DCE5',
                type: 'dashed',
                dashOffset: 3,
              },
            },
          },
          {
            show: this.type !== '动态聚散',
            type: 'value',
            name: `{name|${rightYAxisTitle}}{triangle|▲}`,
            nameTextStyle: {
              rich: {
                name: {
                  color: '#000000',
                },
                triangle: {
                  color: '#5470C6',
                  fontSize: 12,
                  padding: [0, 5, 0, 0],
                },
              },
            },
            position: 'right',
            axisLabel: {
              color: '#000000',
              formatter: '{value}',
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#D5DCE5',
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },

          },
        ],
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            name: 'False RepTime',
            type: 'scatter',
            symbol: 'rect',
            symbolSize: 6,
            itemStyle: {
              color: '#FF0000',
            },
            data: falseRepTimes,
            yAxisIndex: 0,
            tooltip: {
              show: false,
              formatter: (params) => `${params.value[1]}`,
            },
          },
          {
            name: 'True RepTime',
            type: 'scatter',
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              color: '#00C420',
            },
            data: trueRepTimes,
            yAxisIndex: 0,
            tooltip: {
              show: true,
              formatter: (params) => `${params.value[1]}`,
            },
          },
          {
            name: 'Level',
            type: 'scatter',
            symbol: 'triangle',
            symbolSize: 10,
            itemStyle: {
              color: '#004EFF',
            },
            data: this.type !== '动态聚散' ? levels : [],
            yAxisIndex: 1,
            tooltip: {
              show: true,
              formatter: (params) => `${params.value[1]}`,
            },
          },
        ],
      };

      scoreChart.setOption(option);
    },

    initErrorChart() {
      // 初始化图表
      const chartDom = this.$refs.errorChart;
      const myChart = echarts.init(chartDom);

      // 准备数据
      const categories = ['由发散恢复', '无聚散需求', '由集合恢复', '无聚散至发散',
        '无聚散至集合', '集合到发散', '发散到集合', '保持发散', '保持集合',
      ];
      // const avgValues = this.cdStatusList.map((item) => (item.avg ? (item.avg / 1000) : 0));

      const dataList = [];
      const avgValues = [];
      const correctValues = [];

      for (let i = 0; i < this.cdStatusList.length; i++) {
        const item = this.cdStatusList[i];

        const avg = item.avg ? (item.avg / 1000) : 0;
        avgValues.push(avg);

        const cdStatusV2List = item.cd_status_v2;
        let correctVal = 0;
        let correctNum = 0;
        for (let k = 0; k < cdStatusV2List.length; k++) {
          const cdStatusV2 = cdStatusV2List[k];
          const isCorrect = cdStatusV2.is_correct;
          if (isCorrect === true) {
            correctNum += 1;
          }
        }

        if (correctNum !== 0) {
          correctVal = (correctNum / cdStatusV2List.length).toFixed(2);
        }
        console.log('correctVal', correctVal);
        correctValues.push(correctVal);

        const sd = item.sd ? (item.sd / 1000) : 0;
        const max = avg + sd;
        let min = avg - sd;
        if (min < 0) {
          min = 0;
        }

        dataList.push([i, max, min]);
      }

      // const dataList = this.cdStatusList.map((item, index) => {
      //   const avg = item.avg ? (item.avg / 1000) : 0;
      //   avgValues.push(avg);

      //   const sd = item.sd ? (item.sd / 1000) : 0;
      //   const max = avg + sd;
      //   let min = avg - sd;
      //   if (min < 0) {
      //     min = 0;
      //   }

      //   return [index, max, min];
      // });

      // 配置项
      const option = {
        grid: {
          top: '10%',
          left: '7%',
          bottom: '7%',
          right: '7%',
        },
        xAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            interval: 0,
            color: '#000000',
            fontSize: 10,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#D5DCE5',
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#D5DCE5',
              type: 'dashed',
              dashOffset: 3,
            },
          },
        },
        yAxis: {
          type: 'value',
          name: '反应时间（S）',
          nameTextStyle: {
            color: '#000000',
          },
          position: 'left',
          axisLabel: {
            color: '#000000',
            formatter: '{value}',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#D5DCE5',
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#D5DCE5',
              type: 'dashed',
              dashOffset: 3,
            },
          },
        },
        tooltip: {
          trigger: 'item',
        },
        series: [
          // 正确率点
          {
            name: '平均值',
            type: 'scatter',
            data: correctValues,
            symbolSize: 8,
            itemStyle: {
              color: '#FF0000',
            },
            tooltip: {
              show: true,
              formatter: (params) => `正确率${(params.value * 100).toFixed(0)}%`,
            },
          },
          // 正确率连线（虚线）
          {
            name: '平均值连线',
            type: 'line',
            data: correctValues,
            symbol: 'none',
            lineStyle: {
              color: '#FF0000',
              width: 2,
              type: 'dashed',
            },
            itemStyle: {
              color: '#FF0000',
            },
          },
          // 平均值连线（虚线）
          {
            name: '平均值连线',
            type: 'line',
            data: avgValues,
            symbol: 'none',
            lineStyle: {
              color: '#004EFF',
              width: 2,
              type: 'dashed',
            },
            itemStyle: {
              color: '#004EFF',
            },
          },
          // 平均值点
          {
            name: '平均值',
            type: 'scatter',
            data: avgValues,
            symbolSize: 8,
            itemStyle: {
              color: '#004EFF',
            },
            tooltip: {
              show: true,
              formatter: (params) => {
                // 获取原始数据的对应索引数据
                const item = this.cdStatusList[params.dataIndex];
                const avg = item.avg ? (item.avg / 1000).toFixed(2) : 0;
                const sd = item.sd ? (item.sd / 1000).toFixed(2) : 0;
                return `${avg}±${sd}`;
              },
            },
          },
          // 误差范围
          {
            name: '误差范围',
            type: 'custom',
            renderItem(params, api) {
              const xValue = api.value(0);
              const high = api.value(1);
              const low = api.value(2);

              const point = api.coord([xValue, high]);
              const point2 = api.coord([xValue, low]);

              return {
                type: 'group',
                children: [{
                  type: 'line',
                  shape: {
                    x1: point[0],
                    y1: point[1],
                    x2: point2[0],
                    y2: point2[1],
                  },
                  style: {
                    stroke: '#004EFF',
                    lineWidth: 2,
                  },
                }, {
                  type: 'line',
                  shape: {
                    x1: point[0] - 8,
                    y1: point[1],
                    x2: point[0] + 8,
                    y2: point[1],
                  },
                  style: {
                    stroke: '#004EFF',
                    lineWidth: 2,
                  },
                }, {
                  type: 'line',
                  shape: {
                    x1: point2[0] - 8,
                    y1: point2[1],
                    x2: point2[0] + 8,
                    y2: point2[1],
                  },
                  style: {
                    stroke: '#004EFF',
                    lineWidth: 2,
                  },
                }],
              };
            },
            data: dataList,
            tooltip: {
              show: false,
            },
          },
        ],
      };

      // 使用配置项显示图表
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>

.stereo-table-cell {
    height: 35px;
    display: flex;
    background: #FAFAFA;
    justify-content: center;
    align-items: center;
}

</style>
